import React from 'react';
import {Tooltip} from 'reactstrap';
import PropTypes from 'prop-types';

/**
 * Renders an input-group-addon field
 */
class InputGroup extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            isTooltipOpen: false
        };
    }

    toggleTooltip(){

        this.setState({
            isTooltipOpen: !this.state.isTooltipOpen
        });

    }

    focus(){

        if(this._input)
            this._input.focus();

    }

    select(){

        if(this._input)
            this._input.select();
    }

    /**
     * Gets the value from the input
     * @returns {Function|*}
     */
    getValue(){
        return this._input.value;
    }


    render() {

        const props = this.props;
        const name = props.name;
        return (<div className="input-group mb-3">
            <span className="input-group-addon">{typeof props.icon === "string" ? <i className={props.icon}></i> : props.icon}</span>

            <input type={props.type}
                   id={name}
                   name={name}
                   className={`form-control form-input-addon ${ props.errorMessage ? "form-input-addon-error" : null}`}
                   ref={(input) => this._input = input }
                   placeholder={props.placeholder} disabled={props.disabled} onChange={props.onChange}/>

            {props.errorMessage && <Tooltip isOpen={this.state.isTooltipOpen} target={name} toggle={this.toggleTooltip.bind(this)}
                                            autohide={true}
                                            placement={"top"}
                                            delay={10}
                                            className="alert-danger">{props.errorMessage}</Tooltip>}
        </div>);
    }
}

InputGroup.propTypes = {
    placeholder: PropTypes.string,
    type: PropTypes.string,
    errorMessage : PropTypes.string,
    icon : PropTypes.any,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    name: PropTypes.string
};

export default InputGroup;



// WEBPACK FOOTER //
// ./src/components/InputGroup/InputGroup.js